import { Box, Tooltip } from "@mui/material";
import type { ReactNode } from "react";

interface DataFreshnessFooterProps {
  text?: string;
  tooltip?: string;
  icon?: ReactNode;
}

export const DataFreshnessFooter = ({ text, tooltip, icon }: DataFreshnessFooterProps) => {
  if (!text) {
    return null;
  }

  const content = (
    <Box
      sx={{
        alignItems: "center",
        color: "text.secondary",
        display: "inline-flex",
        fontSize: "0.75rem",
        gap: 0.5,
        lineHeight: 1.35,
      }}
    >
      {icon ? (
        <Box component="span" sx={{ display: "inline-flex", flexShrink: 0 }}>
          {icon}
        </Box>
      ) : null}
      <span>{text}</span>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", justifyContent: "center", pb: 2.5, pt: 2 }}>
      {tooltip ? <Tooltip title={tooltip}>{content}</Tooltip> : content}
    </Box>
  );
};
